export default __webpack_public_path__ + "e4bfa8eb04696d4fd5ea04ca4c35469b.svg";